export const userIsSuperAdmin = (user: any) => {
  if ((user.permissions || []).length > 0) {
    for (const permission of user.permissions) {
      if (permission.superAdmin) {
        return true;
      }
    }
  }
  return false;
};
